<template>
  <v-card class="pb-3">
    <v-card-title primary-title class="pb-2 pl-1">
      <div class="px-2">
        {{ role.id ? $t("edit_record") : $t("new_record") }}
      </div>
      <v-divider />
      <v-btn icon @click="reset">
        <v-icon class="pink--text">close</v-icon>
      </v-btn>
    </v-card-title>

    <v-layout wrap justify-center class="pt-3">
      <v-text-field
        outline
        placeholder=" "
        :label="$t('name')"
        class="flex xs11"
        data-vv-name="name"
        v-model="role.name"
        :data-vv-as="$t('name')"
        v-validate="'required|min:3'"
        :error-messages="errors.collect('name')"
      />
      <permission
        class="flex xs11"
        :hide_actions="true"
        :permissions="role.permissions"
      />
      <v-layout row reverse class="flex xs11 pt-3">
        <v-btn color="primary" @click="submit" class="ml-0" :loading="loading">
          <span>{{ $t("save") }}</span>
        </v-btn>
      </v-layout>
    </v-layout>
  </v-card>
</template>
<script>
import { mapGetters } from "vuex";
import permission from "./permissions.vue";

export default {
  components: { permission },
  props: {
    role: {
      default: function () {
        return {
          id: null,
          name: null,
          permissions: [],
        };
      },
    },
  },

  data: () => ({ loading: false }),
  methods: {
    submit() {
      this.loading = true;
      this.$validator.validateAll().then((result) => {
        if (result) {
          let final_ids = [];
          let permissions = this.role.permissions;
          for (let key in permissions) {
            if (permissions[key].value) final_ids.push(permissions[key].id);
          }

          if (final_ids.length === 0) {
            this.$store.commit("showSnackbar", {
              text: "هیچ بخشی انتخاب نشده است.",
              stateType: "error",
              show: true,
            });
          } else {
            this.axios
              .post("roles", {
                id: this.role.id,
                name: this.role.name,
                permissions: final_ids,
              })
              .then((res) => {
                this.$store.commit("showSnackbar", {
                  text: this.$t("save_succeed"),
                  stateType: "success",
                  show: true,
                });
                this.$emit("saved", res.data.data);
              });
          }
          this.loading = false;
        } else {
          this.$store.commit("showSnackbar", {
            text: this.$t("wrong_input"),
            stateType: "error",
            show: true,
          });
          this.loading = false;
        }
      });
    },
    reset() {
      this.$emit("closed");
    },
  },
};
</script>